import styled from 'styled-components';

import { IconZoomIn } from 'assets/icons';

import { HostDashBoard } from '../../containers/Menu/graphQL/types';

import Row from 'components/common/Row';
import Text from 'components/common/Text';
import Column from 'components/common/Column';

const ListSectionHeader = styled.div<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  position: sticky;
  top: 0px;
  left: 0;
  z-index: 15;

  width: 100%;
  padding: ${props => (props.$isMobile ? '24px 20px' : '32px 40px')};

  background-color: #fff;
`;

const DetailButton = styled.button`
  width: fit-content;
  min-width: 52px;
  padding: 0 10px;

  border-radius: 8px;
  background-color: rgba(244, 244, 245, 1);

  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
  letter-spacing: -1%;
  color: rgba(70, 71, 76, 1);
`;

interface Props {
  handleDetailModal: () => void;
  hasAppliedPeriodFilter: boolean;
  hostDashBoard: HostDashBoard;
  handleOverviewModal: () => void;
  isMobile: boolean;
}

function SaleHeader({
  handleDetailModal,
  hasAppliedPeriodFilter,
  hostDashBoard,
  handleOverviewModal,
  isMobile,
}: Props) {
  return (
    <>
      <ListSectionHeader $isMobile={isMobile}>
        <Text
          weight={500}
          size="24px"
          style={{ lineHeight: '32px' }}
          color="rgba(27, 28, 30, 1)"
        >
          판매
        </Text>

        <Row gap="4px" onClick={handleDetailModal}>
          <IconZoomIn
            width={18}
            height={18}
            color={
              hasAppliedPeriodFilter
                ? 'rgba(0, 113, 233, 1)'
                : 'rgba(152, 155, 162, 1)'
            }
          />
          <Text
            weight={500}
            size="16px"
            color={
              hasAppliedPeriodFilter
                ? 'rgba(0, 113, 233, 1)'
                : 'rgba(152, 155, 162, 1)'
            }
            style={{ lineHeight: '22px' }}
          >
            상세조회 {hasAppliedPeriodFilter && '적용 중'}
          </Text>
        </Row>
      </ListSectionHeader>

      <Row
        justifyContent="space-between"
        gap="32px"
        style={{
          width: '100%',
          marginBottom: '24px',
          padding: isMobile ? '0px 20px' : '0px 40px',
        }}
      >
        <Column gap="6px" align="flex-start">
          <Text
            weight={500}
            size="13px"
            style={{ lineHeight: '18px' }}
            color="rgba(27, 28, 30, 1)"
          >
            이번 달 판매금액
          </Text>
          <Text
            weight={600}
            size="24px"
            style={{ lineHeight: '30px' }}
            color="rgba(27, 28, 30, 1)"
          >
            {hostDashBoard?.hostDashboard?.hostDashboard?.monthlyTurnover
              ? Number(
                  hostDashBoard.hostDashboard.hostDashboard.monthlyTurnover,
                ).toLocaleString()
              : 0}
            원
          </Text>
        </Column>

        <DetailButton onClick={handleOverviewModal}>자세히</DetailButton>
      </Row>
    </>
  );
}

export default SaleHeader;
